const store = {
  loginUrl: '',
  loginTitle:'欢迎使用哈啰出行', // 默认标题
  codeEnv: 'pro', // 默认环境为pro
};

export default store;
